import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import Spinner from "../../components/atoms/spinnerV2";
import { Footer } from "../../components/templates";
import Top from "../../components/templates/topV2";
import Text from "../../utils/dictionaries/dictionary-use-account-management";
import Title from "../../components/atoms/titleV2";
import { useRedux } from "../../hooks/useRedux";
import { onUseAccountManagement } from "../../redux/slices/clientInformation";
import Management from "./management";
import Use from "./use";
import validationSchema from "./schema";
import { useApi } from "../../hooks/useApi";
import PERSONALDATA from "../../services/personalData.service";
import { useMaxMinByDeposit } from "../../hooks/useMaxMinByDeposit";
import { useFollowLater } from "../../hooks/useFollowLater";
import { useDinamicSurvey } from './hooks/useDinamicSurvey';
import { useModalError } from "../../hooks/useModalError";
import "./style.scss";


const { postLaborAndUseAccountInformation } = new PERSONALDATA();

const UseAccountManagement = () => {
  const { isModaError , modaComponente, setIsModalError } = useModalError();
  const navigate = useNavigate();
  const { onClickContinue } = useFollowLater();
  const { dataDinamicSurvey = [], errorDinamicSurvey, isLoadingDinamicSurvey } = useDinamicSurvey();
  const {
    dataMaxMinByDeposit: { amountMax },
  } = useMaxMinByDeposit();
  const {
    data: {
      clientInformation: { useAccountManagement, laborInformation },
      clientPersist: { uuid },
    },
    dispatch,
  } = useRedux();

  const {
    data: dataLaborAndUseAccountInformation = { message:undefined },
    error: errorLaborAndUseAccountInformation,
    execute: executeLaborAndUseAccountInformation,
    isLoading: isLoadingLaborAndUseAccountInformation,
  } = useApi(postLaborAndUseAccountInformation);

  const formik = useFormik({
    initialValues: {
      accountType: useAccountManagement.accountType,
      myAccount: useAccountManagement.myAccount,
      accountFamily: useAccountManagement.accountFamily,
      accountUse: useAccountManagement.accountUse,
      accountOrigin: useAccountManagement.accountOrigin,
      accountMoney: useAccountManagement.accountMoney,
      surve: useAccountManagement.surve ? useAccountManagement.surve : dataDinamicSurvey ,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => console.log(values),
    enableReinitialize: true,
  });

  const btnDisabled = (): boolean => {
    let retVal = true;

    if (
      formik.values.accountType &&
      formik.values.myAccount &&
      formik.values.accountFamily &&
      formik.values.accountUse &&
      formik.values.accountOrigin &&
      formik.values.accountMoney
    ) {
      if (formik.values.accountMoney === amountMax) {
        retVal = true;
      } else {
        retVal = false;
      }
    } else {
      retVal = true;
    }

    return retVal;
  };

  const onOk = () => { 
    dispatch(onUseAccountManagement({ ...formik.values }));
    executeLaborAndUseAccountInformation({
      laborInformation: laborInformation,
      useAccountManagement: formik.values,
      processId: uuid,
    });
  }

  useEffect(() => {
    if (
      dataLaborAndUseAccountInformation?.message && 
      !errorLaborAndUseAccountInformation &&
      !isLoadingLaborAndUseAccountInformation
    ) {
      switch (dataLaborAndUseAccountInformation.message) {
        case "FORM_ERROR":
          navigate("/UseAccountManagement/ups", {
            state: {
              resource: "/UseAccountManagement/ups",
              step: "CONTINUE",
              data: formik.values,
            },
          });
          break;
        case "MEDIUM_OR_HIGH_RISK_ERROR":
          navigate("/UseAccountManagement/management", {
            state: {
              resource: "/UseAccountManagement/management",
              step: "CONTINUE",
              data: formik.values,
            },
          });
          break;
        case "SAVE_OK":
        navigate("/BeneficiariesClient");
          onClickContinue({
            data: formik.values,
            processId: uuid,
            resource: "UseAccountManagement",
            step: "CONTINUE",
          });
        break;
        default:
          setIsModalError(true);
          break;
      }
    } else  if (errorLaborAndUseAccountInformation && !isLoadingLaborAndUseAccountInformation){
      setIsModalError(true);
    }
  }, [dataLaborAndUseAccountInformation, isLoadingLaborAndUseAccountInformation, errorLaborAndUseAccountInformation]);

  const onClickButtonLink = () => {
    navigate("/FollowLater", {
      state: {
        processId: uuid,
        resource: "/UseAccountManagement",
        step: "CONTINUE_AFTER",
        data: formik.values,
      },
    });
    dispatch(onUseAccountManagement({ ...formik.values }));
  };

  return (
    <>
      <Top
        titleHeader={Text.top.titleHeader}
        subTitle={Text.top.subTitle}
        displayLeftImageTitle={"d-block"}
        displayProgressBar={"d-block"}
        classHeader={"mt-2"}
        classProgressBar={"mt-3"}
        valueProgressBar={"50%"}
        onClickGoBackIcon={() => navigate("/LaborInformation")}
      />
      <div className="container_form">
        <div className=" mb-4">
          <Title text={Text.title.titleText} className={"container_form__title-inputs"} />
        </div>
        <div className="">
          {isLoadingDinamicSurvey && !dataDinamicSurvey.length ? <Spinner /> : 
            <>
              <Management formik={formik} />
              <div className="mt-4_3 mb-4_3 ">
                <div className="separator_grey" />
              </div>
              <Use formik={formik} />
            </>
          }
        </div>
      </div>
      
      <Footer
        activeSpinner={isLoadingLaborAndUseAccountInformation}
        disabledButton={btnDisabled()}
        onClickButtonPrimary={() => onOk()}
        onClickButtonLink={() => onClickButtonLink()}
        labelButtonPrimary={Text.button.labelButtonPrimary}
        labelButtonSecundary={Text.button.labelButtonSecundary}
      />
      {modaComponente}
    </>
  );
};

export default UseAccountManagement;
